






import { Component, Vue, Emit } from "vue-property-decorator";
import AgroIcons from "@/components/agroIcons/AgroIcons.vue";

@Component({
  name: "FarmEmpty",
  components: {
    AgroIcons
  }
})
export default class FarmEmpty extends Vue {
  @Emit("click")
  private emitClick() {}
}
